import {
  packagePricesFromByUnit,
  packageSummaryPricePrecedence
} from 'packages/common/pricing';
import type { Pricing } from 'packages/types';

export function summarizePricing(pricing: Pricing): string | null {
  // Having to wrap the `pricing` to an array for function reuse is a bit of a weird API.
  // It stems from Pricing type not using Money to represent the prices. This makes the
  // currency handling require a bit more code -- and that's why it's easier to reuse
  // a "package list prices starting from" function here.
  const textByUnit = packagePricesFromByUnit([pricing]);

  const summary = packageSummaryPricePrecedence(textByUnit, text => !!text);
  if (summary === null) return null;

  const packagePriceFieldsSize = Object.values(textByUnit).filter(
    formattedPrice => formattedPrice !== null
  ).length;

  if (packagePriceFieldsSize > 1) return `${summary}+`;

  return summary;
}
